import { getNumericParam, setParamIfDefined, toUrl } from "../utils.js";
export const parse = url => {
  const parsedUrl = toUrl(url);
  const width = getNumericParam(parsedUrl, "w") || undefined;
  const height = getNumericParam(parsedUrl, "h") || undefined;
  const quality = getNumericParam(parsedUrl, "q") || undefined;
  parsedUrl.search = "";
  return {
    width,
    height,
    base: parsedUrl.toString(),
    params: {
      quality
    },
    cdn: "cloudimage"
  };
};
export const transform = _ref => {
  let {
    url: originalUrl,
    width,
    height
  } = _ref;
  const url = toUrl(originalUrl);
  setParamIfDefined(url, "w", width, true, true);
  setParamIfDefined(url, "h", height, true, true);
  setParamIfDefined(url, "q", getNumericParam(url, "q"), true);
  return url;
};